<script setup lang="ts">
import FilterField from '@/components/atoms/element-filters/FilterField.vue'
import ItemCategoryMenu from '@/components/atoms/swade/ItemCategoryMenu.vue'

const types = defineModel<string[]>('types', { default: () => [] })
defineProps<{ label?: string; placeholder?: string }>()

const onChange = (event: any): void => {
  types.value = (event?.value ?? []).map((item: any) => item.alias)
}
</script>

<template>
  <FilterField :label="label">
    <ItemCategoryMenu :placeholder="placeholder" :selected="types" @category-selected="onChange" />
  </FilterField>
</template>
